// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCaF1gPlGU0T1budUUoBDKPGcaKkT6QQc8",
    authDomain: "sani-delivery.firebaseapp.com",
    projectId: "sani-delivery",
    storageBucket: "sani-delivery.appspot.com",
    messagingSenderId: "560087911838",
    appId: "1:560087911838:web:c99c4f6894c68cab429a8f",
    measurementId: "G-GX0QR78JE2",
  },
  onesignal: {
    appId: "",
    googleProjectNumber: "",
    restKey: "",
  },
  stripe: {
    sk: "",
  },
  general: {
    symbol: "KSH",
    code: "KES",
  },
};
